import { DEFAULT_RETURN_ROUTING, type PlannedPoint, type ReturnRouting } from './contracts.js';

export function distanceKm(a: Pick<PlannedPoint, 'lat' | 'lng'>, b: Pick<PlannedPoint, 'lat' | 'lng'>): number {
  const radians = Math.PI / 180;
  const lat = (b.lat - a.lat) * radians;
  const lng = (b.lng - a.lng) * radians;
  const h = Math.sin(lat / 2) ** 2 + Math.cos(a.lat * radians) * Math.cos(b.lat * radians) * Math.sin(lng / 2) ** 2;
  return 6371.0088 * 2 * Math.asin(Math.sqrt(Math.min(1, Math.max(0, h))));
}

/** The farthest ordered stop is the turnaround; the destination is never moved. */
export function returnRouteContext(points: PlannedPoint[], settings: Pick<ReturnRouting, 'nearStartKm'> = DEFAULT_RETURN_ROUTING) {
  const start = points[0];
  const destination = points.at(-1);
  const endpointDistanceKm = start && destination ? distanceKm(start, destination) : Infinity;
  let turnaroundIndex = -1;
  let farthest = -1;
  if (start) for (let index = 1; index < points.length - 1; index++) {
    const distance = distanceKm(start, points[index]!);
    if (distance > farthest) { farthest = distance; turnaroundIndex = index; }
  }
  return { endpointDistanceKm, turnaroundIndex, eligible: points.length >= 3 && endpointDistanceKm <= settings.nearStartKm + 1e-9 };
}
